import dayjs from "dayjs";
import { DutyItem, PilotDuty } from "../Generated/avroGraphqlDuty";
import { DutyItemValidationResult } from "./Interfaces";

export function ValidatePilotDuty(pilotDuty: PilotDuty): DutyItemValidationResult[] {
    const errors = [] as DutyItemValidationResult[];
    const dutyItemRequiredFields = ["duty_type_id", "flight_time", "location_start", "location_end", "duty_start", "duty_end"];
    pilotDuty.DutyItems?.map((dutyItem) => {
        validateRequiredFields(dutyItem as DutyItem, dutyItemRequiredFields, errors);
        validateDutyItemTimes(dutyItem as DutyItem, errors);
    });

    return errors;
}

function validateRequiredFields(dutyItem: DutyItem, requiredFields: string[], errors: DutyItemValidationResult[]) {
    const workingFields = requiredFields.slice();
    for (const [fieldName, fieldValue] of Object.entries(dutyItem)) {
        const requiredIndex = workingFields.indexOf(fieldName);
        if (requiredIndex >= 0) {
            if (fieldValue == null || fieldValue === "") {
                errors.push({
                    dutyItemId: dutyItem.id,
                    entityName: fieldName,
                    message: `REQUIRED`,
                });
            }
            workingFields.splice(requiredIndex, 1);
        }
    }
}

function validateDutyItemTimes(dutyItem: DutyItem, errors: DutyItemValidationResult[]) {
    const check = dayjs(dutyItem.duty_start).isBefore(dayjs(dutyItem.duty_end));

    if (!check) {
        errors.push({
            dutyItemId: dutyItem.id,
            entityName: "duty_start",
            message: `START TIME MUST END BEFORE END TIME`,
        });
        errors.push({
            dutyItemId: dutyItem.id,
            entityName: "duty_end",
            message: `END TIME MUST START AFTER START TIME`,
        });
    }
}
